import Vue from 'vue';

export function smartFocus() {
  Vue.nextTick(() => {
    const iFlds = document.querySelectorAll('.w-input .w-input__input');
    if (!iFlds.length) return;

    // eslint-disable-next-line func-names
    let f = Array.from(iFlds).filter((el) => !el.value);
    if (f.length === 0) f = [iFlds[iFlds.length - 1]];
    f[0].focus();

    // eslint-disable-next-line func-names
    iFlds.forEach((el) => {
      if (el.value && el.parentElement) el.parentElement.classList.add('is-moved');
    });
  });
}

export function loadThemeColor() {
  const color = localStorage.getItem('launchpad-theme-color');
  const el = document.querySelector('.b-app-structure__secondary');
  if (color && el) el.style.background = color;
}

export function setThemeColor(color, hasLocalStorage) {
  const el = document.querySelector('.b-app-structure__secondary');

  if (color) {
    if (el) el.style.background = color;
    if (hasLocalStorage) localStorage.setItem('launchpad-theme-color', color);
  } else {
    if (el) el.style.background = '';
    if (hasLocalStorage) localStorage.removeItem('launchpad-theme-color');
  }
}



// WEBPACK FOOTER //
// ./src/utils/uiHelper.js